import { Box } from "@mui/material";
import styles from "./styles";

function BlocDevis() {
  const onClickEvent = () => {
    window._axcb.push((sdk: any) => {
      sdk.on("cookies:complete", (choices: any) => {
        if (choices.Matomo) {
          window._paq.push([
            "trackEvent",
            "Contact",
            "Clic - CTA",
            "En savoir plus - Essayer Vertuloo gratuitement",
          ]);
        }
      });
    });
  };
  return (
    <Box sx={styles}>
      <div className={"containerTexte"}>
        <div className={"contentTexteDevis"}>
          <p>Si vous souhaitez</p>
          <ul>
            <li>
              <strong>
                Sécuriser votre processus de traitement des dossiers
              </strong>{" "}
              de vos candidats locataires,
            </li>
            <li>
              <strong>Élargir le nombre de candidats</strong> locataires
              éligibles à une GLI,
            </li>
            <li>
              <strong>Réduire la vacance locative</strong>,
            </li>
            <li>
              <strong>
                être certain que 100% des locataires éligibles sont garantis
              </strong>
            </li>
          </ul>
          <p>
            Alors <span className="vert">vertuloo</span>{" "}
            <strong>est fait pour vous !</strong>
          </p>
        </div>
      </div>{" "}
      <div className={"containerDevis"}>
        <a href="#contact" onClick={onClickEvent}>
          <span>
            <span>
              {" "}
              Essayez <span className="vertuloo-font-sm vert">vertuloo</span>
            </span>
            <span>gratuitement</span>
          </span>
        </a>
      </div>
    </Box>
  );
}

export default BlocDevis;
